module.exports = __webpack_public_path__ + "img/GY.6dab909d.svg";